<template lang="pug">
v-card.video-embed-card.rounded-lg.secondary.lighten-1(
  width="100%",
  min-width="300px"
)
  iframe.mb-n2.black(
    :src="`https://www.youtube.com/embed/${youtubeId}`",
    frameborder="0",
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen
  )
</template>

<script>
import { getYoutubeCode } from "../utils";

export default {
  props: {
    link: {
      type: String,
      required: true,
    },
  },
  computed: {
    youtubeId() {
      return this.link ? getYoutubeCode(this.link) : "";
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style>
.video-embed-card {
  aspect-ratio: 16/9;
}
.video-embed-card iframe {
  height: 100%;
  width: 100%;
}
</style>